export type FlagshipAccent = 'cyan' | 'pink' | 'yellow'

const ACCENT_ORDER: FlagshipAccent[] = ['cyan', 'pink', 'yellow']

export function flagshipAccentAt(index: number): FlagshipAccent {
  return ACCENT_ORDER[index % ACCENT_ORDER.length]
}

export const FLAGSHIP_ACCENT_VAR: Record<FlagshipAccent, string> = {
  cyan: 'var(--flagship-cyan)',
  pink: 'var(--flagship-pink)',
  yellow: 'var(--flagship-yellow)',
}
